import { callAdminApiGet } from "../../api/apiUtils";

export async function getPortalStatus() {
  const url = `api/status/getportalstatus`;

  return callAdminApiGet(url);
}
